export const getDefaultModalSubHeader = (itemCount: number) =>
  `You have ${itemCount} ${itemCount === 1 ? "item" : "items"} in your cart.`;

export const defaultData = {
  modalHeader: "Welcome back!",
  modalCta: "Proceed to checkout",
  promoBanner: {
    enabled: true,
    title: "Bundle and save!",
    subtitle: "Programs combine multiple courses into one discounted price.",
    CTA: "Go to cart",
  },
  welcomeBackModal: {
    enabled: true,
  },
};
export type ModalData = typeof defaultData;
